import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-wizard-step-docs',
  templateUrl: './wizard-step-docs.component.html',
  styleUrls: ['../wizard-step-basic/wizard-step-basic.component.css'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule]
})
export class WizardStepDocsComponent {
  @Input() formGroup!: FormGroup;
  @Input() propertyType: string = '';

  onFileSelected(event: any, controlName: string) {
    const file = event.target.files[0];
    if (file) {
      this.formGroup.get(controlName)?.setValue(file);
    }
  }

  removeFile(controlName: string) {
    this.formGroup.get(controlName)?.setValue(null);
  }

  getFileName(controlName: string): string {
    const file = this.formGroup.get(controlName)?.value;
    if (file && file.isExisting) return file.name;
    return file instanceof File ? file.name : '';
  }
}
